import Dashboard        from './system/Dashboard';

import CreateSurvey from './system/survey/CreateSurvey';
import Logo             from './system/Logo';
import Papelera         from './system/Papelera';
import SuscripcionStripe from '../stripe/SuscripcionStripe';

// ── i18n ──────────────────────────────────────────────────────────────────────
const T = {
  en: { comingSoon: 'This section is under development' },
  es: { comingSoon: 'Esta sección está en desarrollo'   },
};

export const ComingSoon = ({ section, lang = 'en' }) => {
  const t = lang === 'es' ? T.es : T.en;
  return (
    <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', minHeight: '400px', color: '#6b7280' }}>
      <div style={{ fontSize: '48px', marginBottom: '16px' }}>🚧</div>
      <h2 style={{ fontSize: '24px', fontWeight: '600', marginBottom: '8px', color: '#374151' }}>{section}</h2>
      <p style={{ fontSize: '16px' }}>{t.comingSoon}</p>
    </div>
  );
};

// ── Factory ───────────────────────────────────────────────────────────────────
const route = (id, path, icon, text, component, order, extra = {}) => ({
  id, path, icon, text, component,
  requiresAuth: true, visible: true, order,
  ...extra,
});

// ── Rutas ─────────────────────────────────────────────────────────────────────
export const platformRoutes = [
  route('dashboard',     '/dashboard',     '📊', { en: 'Dashboard',     es: 'Dashboard'     }, Dashboard,                      1),
  route('newSurvey',     '/createSurvey',  '📝', { en: 'Create',        es: 'Crear'         }, CreateSurvey,                   2, {
    pathPattern: /^\/createSurvey(\/[a-zA-Z0-9_-]{16})?$/, hasOptionalParams: true,
  }),
  route('suscripciones', '/suscripciones', '💳', { en: 'Subscriptions', es: 'Suscripciones' }, SuscripcionStripe,              4),
  route('configuracion', '/configuracion', '⚙️', { en: 'Logo',          es: 'Logo'          }, () => <Logo />,                 5),
  route('Papelera',      '/papelera',      '🗑️', { en: 'Trash',         es: 'Papelera'      }, () => <Papelera />,             6),
];

// ── Helpers ───────────────────────────────────────────────────────────────────
export const getRouteText   = (route, lang = 'en') =>
  (lang === 'es' ? route?.text?.es : route?.text?.en) ?? route?.text?.en ?? '';

export const getRouteById       = (id)  => platformRoutes.find((r) => r.id === id);
export const getVisibleRoutes   = ()    => platformRoutes.filter((r) => r.visible).sort((a, b) => a.order - b.order);
export const getRouteComponent  = (id)  => getRouteById(id)?.component ?? null;

export const matchRoutePath = (actualPath) => {
  const p = actualPath.startsWith('/') ? actualPath : `/${actualPath}`;
  return platformRoutes.find((r) =>
    r.pathPattern ? r.pathPattern.test(p) : r.path === p
  ) ?? null;
};

export const getSectionIdFromPath = (path) => {
  const p = path.startsWith('/') ? path : `/${path}`;
  return matchRoutePath(p)?.id ?? p.split('/').filter(Boolean)[0] ?? DEFAULT_ROUTE;
};

export const DEFAULT_ROUTE = 'dashboard';